import { AutorenewRetailPriceComponentModule } from '@b2b/autorenew/components/autorenew-retail-price';
import { CartService, CartServiceModule } from '@b2b/common/services';
import { TODO } from '@b2b/types/core';
import angular from 'angular';

OrderItemPriceDirective.$inject = ['CartService'];
function OrderItemPriceDirective(CartService: CartService) {
  OrderItemPriceController.$inject = ['$scope'];
  function OrderItemPriceController($scope) {
    const ctrl = {
      cartService: CartService,

      model: [] as TODO[], // Everything must be converted to an array

      init: function () {
        $scope.$on('$destroy', $scope.$watch('model.level', ctrl.onModelUpdate));
        $scope.$on('$destroy', $scope.$watch('model', ctrl.onModelUpdate));
        $scope.$on('$destroy', $scope.$watch('model.couponCodes', ctrl.onModelUpdate));
        $scope.$on(
          '$destroy',
          $scope.$watch('orderItemPrice.cartService.itemCount', angular.bind(ctrl, ctrl.normalize))
        );
        $scope.$on(
          '$destroy',
          $scope.$watch(
            'orderItemPrice.cartService.coupons.validCouponCodes.length',
            angular.bind(ctrl, ctrl.normalize)
          )
        );
        ctrl.normalize();
      },

      normalize: function () {
        const model = Array.isArray($scope.model) ? $scope.model : [$scope.model];
        ctrl.model = angular.copy(model);
        ctrl.model = ctrl.model.sort(ctrl.sortByRetail);

        angular.forEach(ctrl.model, function (item) {
          if (item.itemType.toLowerCase().indexOf('membership') > -1) {
            if (item.level) {
              item.orderItemDisplayName = item.level.selectedOffering.displayName;
            }
            item.couponCodes = ctrl.cartService.coupons.findMembershipCoupon(item.membershipInfo);
          } else if (item.itemType.toLowerCase() === 'event') {
            item.orderItemDisplayName = item.ticketingTypeName;
            item.couponCodes = ctrl.cartService.coupons.findEventTicketCoupon(item.eventId, item.ticketingTypeId);
          } else if (item.itemType.toLowerCase() === 'inventory') {
            item.orderItemDisplayName = item.inventoryName;
          }
        });
      },

      sortByRetail: function (a, b) {
        let result = 0;
        const aValue = a.ticketingTypeId || 0;
        const bValue = b.ticketingTypeId || 0;

        if (aValue > bValue) {
          result = 1;
        } else if (aValue < bValue) {
          result = -1;
        } else {
          if (a.isRetail && !b.isRetail) {
            result = 1;
          } else if (!a.isRetail && b.isRetail) {
            result = -1;
          }
        }

        return result;
      },

      getItemRetailSubtotal: function (item) {
        return ctrl.cartService.getItemRetailSubtotal(item);
      },

      getItemDiscountedSubtotal: function (item) {
        return ctrl.cartService.getItemDiscountedSubtotal(item);
      },

      isItemType: function (item, itemType) {
        return item.itemType && item.itemType.indexOf(itemType) > -1;
      },

      isMembershipType: function (item) {
        return ctrl.isItemType(item, 'Membership');
      },

      isEventType: function (item) {
        return ctrl.isItemType(item, 'Event');
      },

      hasDiscount: function (item) {
        return !item.isRetail && item.retailUnitPrice !== item.unitPrice;
      },

      isEventWithDiscount: function (item) {
        return ctrl.isEventType(item) && ctrl.hasDiscount(item);
      },

      isEventWithMembershipDiscount: function (item: { couponCodes?: TODO[] }) {
        return item.couponCodes?.length === 0 && ctrl.isEventWithDiscount(item);
      },

      isAutorenewMembership: function (item) {
        return (
          ctrl.isMembershipType(item) &&
          CartService.memberships.isAutorenewType({
            autorenewalType: item.membershipInfo.autorenewalType,
          })
        );
      },

      onModelUpdate: function (n, o) {
        if (n) {
          ctrl.normalize();
        }
      },
    };

    $scope.orderItemPrice = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/order/item/price/price.tpl.html',
    scope: {
      model: '=',
      itemTypeLabel: '@',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: OrderItemPriceController,
  };
}

export const OrderItemPriceDirectiveModule = angular
  .module('acme.common.directive.order.item.price', [CartServiceModule, AutorenewRetailPriceComponentModule])
  .directive('orderItemPrice', OrderItemPriceDirective).name;
